import { render, staticRenderFns } from "./SegmentationRuleForm.vue?vue&type=template&id=61dc1d47&scoped=true&lang=pug&"
import script from "./SegmentationRuleForm.vue?vue&type=script&lang=ts&"
export * from "./SegmentationRuleForm.vue?vue&type=script&lang=ts&"
import style0 from "./SegmentationRuleForm.vue?vue&type=style&index=0&id=61dc1d47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc1d47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VCol,VContainer,VForm,VRadio,VRadioGroup,VRow,VSwitch,VTextField})
